import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import Home from 'pages/Home/Home'
import Products from 'pages/Products/Products'
import ProductDetail from 'pages/ProductDetail/ProductDetail'
// import AboutUs from 'pages/AboutUs/AboutUs';
// import Faq from 'pages/Faq/Faq';
import Login from 'pages/Login/Login'
import Dashboard from 'pages/Dashboard/Dashboard'
import ProductForm from 'pages/ProductForm/ProductForm'
import NotFound from 'pages/NotFound/NotFound'

import Entrega from 'pages/Entrega/Entrega'
import PoliticaPrivacidade from 'pages/PoliticaPrivacidade/PoliticaPrivacidade'
import DevolucaoTroca from 'pages/DevolucaoTroca/DevolucaoTroca'

const routes = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/products', element: <Products /> },
  { path: '/product/:id', element: <ProductDetail /> },
  // Outras rotas comentadas...
  { path: '/admin', element: <Login /> },
  { path: '/dashboard', element: <Dashboard /> },
  // Rota para cadastro de produto
  { path: '/product-form', element: <ProductForm /> },
  // Rota para edição de produto (id será capturado no ProductForm)
  { path: '/product-form/:id', element: <ProductForm /> },
  { path: '/entrega', element: <Entrega /> },
  { path: '/troca-e-devolucao', element: <DevolucaoTroca /> },
  { path: '/politica-de-privacidade', element: <PoliticaPrivacidade /> },
  { path: '*', element: <NotFound /> },
])

export default function App() {
  return <RouterProvider router={routes} />
}
